const initialState = {
    refresh: false,
  };
  
  const refreshMuiReducer = (state = initialState, action) => {
      const {type} = action;
      switch(type) {
          case "REFRESHMUIIN":
              return {...state,refresh:true}
          case "REFRESHMUIOUT":
              return {...state,refresh:false}
          default:
              return state;
      }
  };
  
  export default refreshMuiReducer;